import { defineStore } from "pinia";
import type { IUserLogged } from "~/interfaces/IUserLogged";

export const useAuthorizedDeviceStore = defineStore("authorizedDevice", {
  state: () => ({
    user: null as IUserLogged | null,
  }),

  getters: {
    isDeviceVerified: (state) => state.user?.authorized_device === true,
  },

  actions: {
    loadUserFromLocalStorage() {
      const raw = localStorage.getItem("customer");
      if (raw) {
        this.user = JSON.parse(raw);
      }
    },

    markDeviceAsVerified(deviceToken: string) {
      if (this.user) {
        this.user.authorized_device = true;
        localStorage.setItem("customer", JSON.stringify(this.user));
        localStorage.setItem("device_token", deviceToken);
      }
    },
  },
});
